export const AUTH_USER_KEY = ["auth-user"];

export const getAuthUser = () => {
  const userData = localStorage.getItem("userData");
  return userData ? JSON.parse(userData) : null;
};